import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, ArrowRight } from 'lucide-react';

export default function DemoBanner() {
  return (
    <div
      className="w-full bg-[#2196F3] text-white px-4 py-2 flex items-center justify-center gap-3 text-sm relative z-50"
      data-testid="demo-project-banner"
    >
      <Sparkles className="h-4 w-4 flex-shrink-0 opacity-80" />
      <span className="font-medium">Demo Project</span>
      <span className="hidden sm:inline text-white/80">|</span>
      <Link
        to="/register?upgrade=demo"
        className="hidden sm:inline-flex items-center gap-1 text-white font-semibold hover:underline underline-offset-2"
        data-testid="demo-banner-trial-link"
      >
        Use Pulse on your Project! — Start your 30-Day Free Trial
        <ArrowRight className="h-3.5 w-3.5" />
      </Link>
      <Link
        to="/register?upgrade=demo"
        className="sm:hidden inline-flex items-center gap-1 text-white font-semibold hover:underline underline-offset-2"
        data-testid="demo-banner-trial-link-mobile"
      >
        Start Free Trial
        <ArrowRight className="h-3.5 w-3.5" />
      </Link>
    </div>
  );
}
